import { Navigate, Route, Routes } from 'react-router-dom';
import ChecklistEditorStudent from '../../pages/ChecklistEditorStudent';
import ChecklistStudentPage from '../../pages/ChecklistStudent';
import ExamEditorStudent from '../../pages/ExamEditorStudent';
import ExamStudentPage from '../../pages/ExamStudent';
import HomeworkStudent from '../../pages/HomeworkStudent';
import Library from '../../pages/Library';
import MaterialView from '../../pages/MaterialView';
import NewNotebook from '../../pages/NewNotebook';
import Schedule from '../../pages/Schedule';
import StudentHomeworkList from '../../pages/StudentHomeworkList';
import StudentMaterials from '../../pages/StudentMaterials';
import StudentProfile from '../../pages/StudentProfile';
import StudentHome from '../../pages/StudentHome/StudentHome';
import PublicMaterial from 'pages/PublicMaterial';

const Student = ({ userType, user }) => {
  return (
    <Routes>
      <Route path="/" element={<StudentHome />} />
      <Route path="/schedule" element={<Schedule mail={user.mail} />} />
      <Route path="/student-materials/:nameItem" element={<StudentMaterials mail={user.mail} />} />
      <Route path="/student-materials/:nameItem/:subject" element={<StudentMaterials mail={user.mail} />} />
      <Route path="/notebook/:mail/:subject" element={<NewNotebook typeUser={userType} />} />
      <Route path="/notebook/:mail/:subject/:homework" element={<NewNotebook typeUser={userType} mail={user.mail} />} />
      <Route path="/student-homework-list/:subject" element={<StudentHomeworkList mail={user.mail} />} />
      <Route path="/library" element={<Library />} />
      {/*<Route path="/editExam/:subject" element={<EditExam mail={user.mail} />} />
              <Route path="/editExam" element={<EditExam />} />*/}
      <Route path="/materialView" element={<MaterialView />} />
      <Route path="/profile" element={<StudentProfile mail={user.mail} />} />
      <Route path="/checklist-editor-student/:checklistId" element={<ChecklistEditorStudent mail={user.mail} />} />
      <Route path="/exam-editor-student/:examId" element={<ExamEditorStudent mail={user.mail} />} />
      <Route path="/checklist-student" element={<ChecklistStudentPage mail={user.mail} />} />
      <Route path="/exam-student" element={<ExamStudentPage mail={user.mail} user={user} />} />
      <Route path="/hw-student" element={<HomeworkStudent />} />
      <Route path="*" element={<Navigate to="/" />} />
      <Route path="/publicMaterial/:id" element={<PublicMaterial />} />
    </Routes>
  );
};

export default Student;
